export default __webpack_public_path__ + "static/bankid-gor-processen-snabbare-80521b2ec66db20215b26f53b2aeb36f.jpg";